import { useTranslate } from '@tolgee/react';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useMemo } from 'react';

/**
 * RECOMMEND 智能推荐排序
 * SALE 销量
 * UPDATE_TIME 更新时间
 */
export type OrderBy = 'RECOMMEND' | 'SALE' | 'UPDATE_TIME';

interface ProductPickerSortProps {
  channel: Conversation.Conversation['channel'];
  orderBy: OrderBy;
  onChange: (orderBy: OrderBy) => void;
}
export const ProductPickerSort = (props: ProductPickerSortProps) => {
  const { channel, orderBy, onChange } = props;
  const { t } = useTranslate();

  const orderByOptions: OrderBy[] = useMemo(() => {
    if (channel === 'LAZADA') {
      return ['RECOMMEND', 'UPDATE_TIME'];
    }
    return ['RECOMMEND', 'SALE', 'UPDATE_TIME'];
  }, [channel]);

  const orderByLabelMap = useMemo(() => {
    return {
      RECOMMEND: t('智能推荐'),
      SALE: t('orderBy.SALE'),
      UPDATE_TIME: t('orderBy.UPDATE_TIME'),
    };
  }, [t]);

  return (
    <Dropdown
      overlay={
        <Menu
          selectedKeys={[orderBy]}
          onClick={({ key }) => {
            if (key === orderBy) {
              return;
            }

            onChange(key as OrderBy);
          }}
        >
          {orderByOptions.map((key) => {
            return <Menu.Item key={key}>{orderByLabelMap[key]}</Menu.Item>;
          })}
        </Menu>
      }
    >
      <span className="cursor-pointer hover:opacity-80 flex items-center gap-1 px-3">
        {orderByLabelMap[orderBy]}
        <DownOutlined />
      </span>
    </Dropdown>
  );
};
